import config from '@/config'
import { getQueryString } from '@/lib/utils'

function invoice(seq, name, userSeq) {
  let url = `${config.api.baseUri}/download/invoice/${seq}/${name}`

  if (userSeq) {
    url = `${config.api.baseUri}/download/${userSeq}/invoice/${seq}/${name}`
  }

  window.open(url, '_blank')
}

function invoiceUsage(seq, userSeq) {
  let url = `${config.api.baseUri}/download/invoice_usage/${seq}`

  if (userSeq) {
    url = `${config.api.baseUri}/download/${userSeq}/invoice_usage/${seq}`
  }

  document.location.href = url
}

function invoiceUsages(month, seqs) {
  const query = {
    month,
    seqs,
  }
  const url = `${config.api.baseUri}/download/invoice/usages?${getQueryString(
    query
  )}`

  document.location.href = url
}

function report(seq, name, userSeq) {
  let url = `${config.api.baseUri}/download/report/${seq}/${name}`

  if (userSeq) {
    url = `${config.api.baseUri}/download/${userSeq}/report/${seq}/${name}`
  }
  window.open(url, '_blank')
}

function privacyPolicy() {
  const url = `${config.api.baseUri}/download/privacy_policy`

  window.open(url, '_blank')
}

export default {
  invoice,
  invoiceUsage,
  report,
  privacyPolicy,
  invoiceUsages,
}
